import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../../../../../utils/Context';
import Select from 'react-select';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { GET_CG_PREMIUM } from '../../../../../../api/endpoint';
import { getRequest } from '../../../../../../api/api';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { ToastManager } from '../../../../../../ToastContainer/ToastContainer';
import './cargo.scss';
import { formatInput } from '../../../../../../utils/Commonutils';
import ScrollToTopLink from '../../../../../ScrollToTop/ScrollToTop';
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { ImCross } from 'react-icons/im';

const Cargo = ({
  current,
  setCurrent,
  handleTabChange,
  getSubscriptionFor,
  CGpolicyListingRepsonse,
  CGPolicyDetailsListing,
  saveProfile,
  isDirectCheckout,
}) => {
  const [params, setParams] = useState(null);
  const [CGdeductPolicy, setCGdeductPolicy] = useState(1000);
  const [CGPolicy, setCGPolicy] = useState();
  const { profileObject, setDirectCheckout } = useContext(Context);
  const [cgSubObj, setcgSubObj] = useState({});
  const [cargoPolicyMsg, setCargoPolicyMsg] = useState('');
  const [isCargoAvailable, setIsCargoAvailable] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isCoverageDeclined, setIsCoverageDeclined] = useState(false);
  const [cgPremium, setCGPremium] = useState(null);

  useEffect(() => {
    setcgSubObj(getSubscriptionFor('CG'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileObject]);

  useEffect(() => {
    if (cgSubObj && Object.keys(cgSubObj).length !== 0) {
      setParams({
        cg_max_value: cgSubObj?.cg_max_value,
        cargo_deductible: parseInt(cgSubObj?.cargo_deductible),
      });
      setCGdeductPolicy(parseInt(cgSubObj?.cargo_deductible));
      const cg_limit = {
        value: parseInt(cgSubObj?.cg_max_value),
        label: `$${parseInt(cgSubObj?.cg_max_value).toLocaleString('en-US')}`,
      };
      setCGPolicy(cg_limit);
      setCGPremium((prev) => ({
        ...prev,
        calculated_premium: cgSubObj?.calculated_total,
      }));
      setIsCoverageDeclined(false);
    } else {
      setIsCoverageDeclined(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cgSubObj]);

  const handleCargoLimitChange = (cargoLimit) => {
    const cargo_limit = {
      ...params,
      cg_max_value: cargoLimit.value,
    };
    setCGPolicy(cargoLimit);
    setParams(cargo_limit);
    calculateCGPremium(cargo_limit);
  };

  const handleDeductChange = (deductible) => {
    const deductible_param = {
      ...params,
      cargo_deductible: deductible,
    };
    setCGdeductPolicy(deductible);
    setParams(deductible_param);
    calculateCGPremium(deductible_param);
  };

  const calculateCGPremium = async (params) => {
    try {
      const response = await getRequest(GET_CG_PREMIUM, params);
      setCargoPolicyMsg(response?.result?.message);
      setCGPremium(response?.result);
    } catch (error) {
      console.log('API error', error);
    }
  };

  useEffect(() => {
    if (params != null) {
      calculateCGPremium(params);
    } else {
      setParams({
        cargo_deductible: CGdeductPolicy,
      });
      calculateCGPremium();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const handleCGSave = (isCheckout = false) => {
    setButtonLoading(true);
    if (isCoverageDeclined) {
      handleDecline();
      setButtonLoading(false);
      return false;
    }

    if (CGPolicy === undefined) {
      setButtonLoading(false);
      ToastManager.error('Select Cargo Limit');
      return false;
    }
    const cgSubscription = getSubscriptionFor('CG');
    const data = {
      programs_attributes: [
        {
          id: profileObject?.programs[0]?.id,
          subscriptions_attributes: [
            {
              ...params,
              id: cgSubscription.id,
              subject_type: 'Program',
              subject_id: profileObject?.programs[0]?.id,
              subscribable_type: 'PolicyDetail',
              subscribable_id: CGpolicyListingRepsonse[0]?.id,
              type: 'YearlySubscription',
            },
          ],
        },
      ],
      vehicle_details_attributes: [{}],
    };
    saveProfile(data).then((success) => {
      if (success) {
        CGPolicyDetailsListing();
        if (isCheckout) {
          setDirectCheckout(true);
          isDirectCheckout('CG');
        } else {
          setDirectCheckout(false);
          window.scrollTo(0, 0);
          handleTabChange('nonTruckingBobtail');
        }
      }
      setButtonLoading(false);
    });
  };

  let cgPolicyData = [
    {
      label: 'Cargo',
      id: 'cargo',
      type: 'radio',
      name: 'policy',
      value: 'cargo',
      planName: 'Cargo',
    },
  ];

  useEffect(() => {
    let cargoNotAvailable =
      (cargoPolicyMsg && cargoPolicyMsg.length) > 1 ||
      (cgPremium?.cargo_commodity_premiums &&
        cgPremium?.cargo_commodity_premiums.some(
          (commodity) => commodity.not_available
        ));
    setIsCargoAvailable(!cargoNotAvailable);
  }, [cargoPolicyMsg, cgPremium]);

  const deductibleOption = [
    {
      label: '$1,000',
      value: 1000,
      id: '$1,000',
      type: 'radio',
    },
    {
      label: '$2,500',
      value: 2500,
      id: '$2,500',
      type: 'radio',
    },
    {
      label: '$5,000',
      value: 5000,
      id: '$5,000',
      type: 'radio',
    },
  ];

  const CargoLimitOptions = [
    { value: 10000, label: '$10,000' },
    { value: 25000, label: '$25,000' },
    { value: 50000, label: '$50,000' },
    { value: 75000, label: '$75,000' },
    { value: 100000, label: '$100,000' },
    { value: 150000, label: '$150,000' },
    { value: 200000, label: '$200,000' },
    { value: 250000, label: '$250,000' },
  ];

  const handleDecline = () => {
    const cgSubscription = getSubscriptionFor('CG');
    const data = {
      programs_attributes: [
        {
          id: profileObject?.programs[0]?.id,
          subscriptions_attributes: [
            {
              id: cgSubscription.id,
              _destroy: true,
            },
          ],
        },
      ],
      vehicle_details_attributes: [{}],
    };
    setIsCoverageDeclined(true);
    saveProfile(data).then((success) => {
      if (success) {
        handleTabChange('nonTruckingBobtail');
      }
    });
    return false;
  };

  return (
    <div className="text-start">
      <Row>
        <Form className="user-detail-form-blue">
          <Col md={12}>
            <label className="fw-bold mt-2 mb-2">
              Selected cargo commodities
            </label>
            <br />
            {cgPremium?.cargo_commodity_premiums &&
              cgPremium?.cargo_commodity_premiums.map((each, index) =>
                each && each.name ? (
                  <OverlayTrigger
                    key={index}
                    placement="bottom"
                    overlay={
                      <Tooltip id="tooltip">
                        {each?.not_available
                          ? 'Coverage not available'
                          : 'Coverage Available'}
                      </Tooltip>
                    }
                  >
                    <span
                      key={index}
                      className={` fs-6 mx-1 mb-2 cursor-pointer ${
                        each.not_available
                          ? 'badge bg-secondary cursor-not-allowed opacity-50'
                          : 'badge bg-success'
                      }`}
                    >
                      {each?.name}{' '}
                      {each?.premium > 0
                        ? `- $${formatInput(each?.premium)}`
                        : ''}
                    </span>
                  </OverlayTrigger>
                ) : null
              )}

            <div></div>
          </Col>
          {cgPremium?.cargo_commodity_premiums &&
          cgPremium?.cargo_commodity_premiums.some(
            (commodity) => commodity.not_available
          ) ? (
            <div className="alert alert-warning my-3" role="alert">
              <span className="d-flex align-items-center">
                <BsFillInfoCircleFill />
                <strong className="px-2">Oops, We are Sorry!</strong>
              </span>
              <hr />

              <div>
                <span className="fs-5">
                  Cargo coverage is not available for the selected commodities
                </span>
              </div>
            </div>
          ) : (
            <>
              {cgPremium?.number_of_pu > 0 ? (
                <>
                  <hr className="d-none-desk" />
                  <Col md={12}>
                    <Form.Group className="user-detail-form-blue mt-2 mt-md-4">
                      <Form.Label className="font-16-sm fw-bold mb-0 mb-md-2">
                        Number of Power Units
                      </Form.Label>
                      <div className="fs-5 text-muted fw-bold">
                        {cgPremium?.number_of_pu}
                      </div>
                    </Form.Group>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <Form.Group className="user-detail-form-blue mt-2">
                      <Form.Label className="font-16-sm fw-bold mb-0 mb-md-2">
                        Cargo Limits
                      </Form.Label>
                      <Select
                        className="custom-select"
                        options={CargoLimitOptions}
                        value={CGPolicy}
                        onChange={handleCargoLimitChange}
                        placeholder="Select cargo limit"
                      />
                    </Form.Group>
                  </Col>
                  {/*<hr className="d-none-desk" />*/}
                  <Row>
                    <Form.Label className="font-16-sm fw-bold mb-0 mb-md-2 mt-4 mt-md-4">
                      Deductible (Each & Every Loss / Each & Every Unit)
                    </Form.Label>
                    {deductibleOption.map((option) => (
                      <Col md={3} key={option.value}>
                        <Form.Group>
                          <Form.Check
                            className="radio-label"
                            type={option.type}
                            label={option.label}
                            name={option.name}
                            value={option.value}
                            checked={CGdeductPolicy === option.value}
                            onChange={() => handleDeductChange(option.value)}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    ))}
                    <hr className="mt-20-sm-imp d-none-desk" />
                    <Form.Label className="font-16-sm fw-bold mt-2 mt-md-5">
                      Cargo Policy
                      <span className="text-danger">&nbsp;*</span>
                    </Form.Label>
                    {cgPolicyData.map((field) => (
                      <div className="pricing-plan" key={field.id}>
                        <div className="box row my-3 cursor-pointer">
                          <Col
                            md={6}
                            lg={6}
                            sm={12}
                            key={field.id}
                            className="mb-2"
                          >
                            <Form.Group
                              className={`card ${
                                isCoverageDeclined ? '' : 'selected'
                              }`}
                              controlId={field.id}
                              onClick={() => setIsCoverageDeclined(false)}
                            >
                              <div className="d-flex justify-content-end">
                                <Form.Check
                                  type={field.type}
                                  name={field.plan_type?.name}
                                  value={field.plan_type?.code_name}
                                  checked={!isCoverageDeclined}
                                  readOnly
                                />
                              </div>
                              <>
                                <span className="plan-details text-center">
                                  <span className="plan-type">
                                    {field.planName}
                                  </span>
                                </span>
                                <span className="plan-cost text-center">
                                  $
                                  {formatInput(
                                    cgPremium?.calculated_premium?.toFixed(2)
                                  )}
                                  <span className="slash">/</span>
                                  <span className="plan-cycle" title="year">
                                    yr
                                  </span>
                                </span>
                                <div className="d-flex justify-content-between">
                                  <span className="text-black m-0 m-md-2 fs-5 font-16-sm">
                                    Total{' '}
                                  </span>
                                  <span className="text-muted fw-bold text-center fs-4 pt-2">
                                    $
                                    <span>
                                      {formatInput(
                                        cgPremium?.calculated_premium?.toFixed(
                                          2
                                        )
                                      )}
                                      /yr
                                    </span>
                                  </span>
                                </div>
                                <span className="text-muted fw-bold text-end fs-5 pt-2">
                                  {cgPremium?.monthly_premium > 0 ? '$' : ''}
                                  {cgPremium?.monthly_premium > 0 ? (
                                    <>
                                      {formatInput(
                                        cgPremium?.monthly_premium?.toFixed(2)
                                      )}
                                      <span className="slash">/</span>
                                      <span className="" title="month">
                                        month
                                      </span>
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </span>
                                <span className="text-muted fw-bold text-end fs-6 pt-2">
                                  {cgPremium?.weekly_premium > 0 ? '$' : ''}
                                  {cgPremium?.weekly_premium > 0 ? (
                                    <>
                                      {formatInput(
                                        cgPremium?.weekly_premium?.toFixed(2)
                                      )}
                                      <span className="slash">/</span>
                                      <span className="" title="week">
                                        wk
                                      </span>
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </span>
                              </>
                            </Form.Group>
                          </Col>
                          <Col
                            md={6}
                            lg={6}
                            sm={12}
                            className="box cursor-pointer"
                          >
                            <Form.Group
                              className={`mb-3 card h-100 ${
                                isCoverageDeclined ? 'selected' : ''
                              }`}
                              onClick={() => setIsCoverageDeclined(true)}
                            >
                              <div className="d-flex justify-content-end">
                                <Form.Check
                                  type="radio"
                                  name="coverageDeclined"
                                  value="coverageDeclined"
                                  checked={isCoverageDeclined ? true : false}
                                  readOnly
                                />
                              </div>
                              <span className="plan-details">
                                <span className="text-center mb-2">
                                  <ImCross color="red" size={30} />
                                </span>

                                <span className="plan-type text-center">
                                  Decline Coverage
                                </span>
                                <p className="text-center fs-6 py-3">
                                  I do not wish to take this coverage.
                                </p>
                              </span>
                            </Form.Group>
                          </Col>
                        </div>
                      </div>
                    ))}
                  </Row>
                </>
              ) : (
                <></>
              )}
            </>
          )}
          {/*<hr />*/}
          {(cargoPolicyMsg && cargoPolicyMsg.length) < 1 && (
            <div className="alert alert-warning" role="alert">
              <span className="d-flex flex-direction-C">
                <div className="d-flex align-items-center">
                  <BsFillInfoCircleFill />
                  <strong className="px-2">Note:</strong>
                </div>
                <span>
                  We are not providing this service in the following states: New
                  York, Indiana.{' '}
                </span>
              </span>
            </div>
          )}

          {(cargoPolicyMsg && cargoPolicyMsg.length) > 1 && (
            <div className="alert alert-danger mt-2" role="alert">
              <span className="d-flex flex-direction-C">
                <div className="d-flex align-items-center">
                  <BsFillInfoCircleFill />
                  <strong className="px-2">Note:</strong>
                </div>
                <span>{cargoPolicyMsg}</span>
              </span>
            </div>
          )}
          <span className="navigation_bottom navi_pad">
            <div className="d-flex justify-content-between align-items-center flex-direction-C mb-2 a_100_sm">
              <ScrollToTopLink className="w-100-sm">
                <Button
                  className="btn w-100-sm silo-btn-small silo-btn__white mb-2 my-md-3"
                  onClick={() => handleTabChange('physicalDamage')}
                >
                  Back
                </Button>
              </ScrollToTopLink>
              {cgPremium?.number_of_pu === 0 ||
              (cgPremium?.cargo_commodity_premiums &&
                cgPremium?.cargo_commodity_premiums.some(
                  (commodity) => commodity.not_available
                )) ? (
                <span className="w-100-sm">
                  <Button
                    className="btn w-100-sm silo-btn-small silo-btn__blue"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      handleTabChange('nonTruckingBobtail');
                    }}
                  >
                    Move to Next Coverage
                  </Button>
                </span>
              ) : (
                <div className="d-flex justify-content-end flex-direction-C w-100-sm">
                  <span className="w-100-sm">
                    <Button
                      className="btn w-100-sm silo-btn-small silo-btn__blue my-2 my-md-3 mt-md-0"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        handleCGSave(false);
                      }}
                    >
                      {buttonLoading ? (
                        <Spinner size="sm" />
                      ) : !isCoverageDeclined ? (
                        <>Save & Next Coverage</>
                      ) : (
                        <>I do not want this coverage</>
                      )}
                    </Button>
                  </span>
                </div>
              )}
            </div>
            {isCargoAvailable && !isCoverageDeclined && (
              <div>
                <span
                  className="text-primary fw-bold cursor-pointer"
                  onClick={() => handleCGSave(true)}
                >
                  <u>Save & Proceed to Checkout</u>
                </span>
              </div>
            )}
          </span>
        </Form>
      </Row>
    </div>
  );
};

export default Cargo;
